module.exports = __webpack_public_path__ + "img/subAra8.cd88a239.jpg";